module.exports = __webpack_public_path__ + "static/img/icon-pro3.442121c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-pro3.jpg
// module id = AOdl
// module chunks = 21